module.exports = __webpack_public_path__ + "media/10.983c4aa9.wav";